import { router } from "@smakecloud/api-client-helper";
import { z } from "zod";
import { authedEndpoint } from "~/lib/api/builder";

const verify = authedEndpoint.query(
    () => ({
        url: "production/verify",
    }),
    {
        output: z.object({
            id: z.number(),
            name: z.string(),
            channel: z.string(),
            created_at: z.iso.datetime({ offset: true }),
            default_locale_code: z.string(),
            default_locale_id: z.number(),
            deleted_at: z.iso.datetime({ offset: true }).nullable(),
            handle: z.string(),
            locales: z.array(
                z.object({
                    id: z.number(),
                    name: z.record(z.string(), z.string()),
                    code: z.string(),
                }),
            ),
            owner_id: z.number().nullable(),
            tenant_id: z.number(),
            timezone: z.string(),
            updated_at: z.iso.datetime({ offset: true }),
            workflow_type: z.string(),
        }),
    },
);

export const production = router({
    verify,
});
